import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import gr from './locales/gr.json';

const resources = {
  en: { translation: en },
  gr: { translation: gr }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    // Iter408 — Greek-first everywhere. Ignore browser/system language; always
    // default to Greek unless the user has explicitly chosen a language before
    // (persisted in localStorage). Manual EN switch stays available in the menu.
    lng: localStorage.getItem('language') || 'gr',
    fallbackLng: 'gr',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;